import { Button } from 'components/ui';
import { useModal } from 'contexts/modal';
import { useInfo } from 'contexts/info';
import { FormattedMessage } from 'react-intl';
import Edit from 'components/space/billing_details/modal/edit';

const EditButton = ({ billingDetails, refetch }) => {
  const { addModal, removeModal } = useModal();
  const setInfo = useInfo();

  return (
    <Button
      variant="contained"
      onClick={() => {
        addModal(
          <Edit
            billingDetails={billingDetails}
            onSuccess={() => {
              refetch();
              removeModal();
              setInfo('info.billing_details.edited');
            }}
            handleClose={() => removeModal()}
          />,
          { disableAutoFocus: true, disableRestoreFocus: true }
        );
      }}
    >
      <FormattedMessage id="button.edit" />
    </Button>
  );
};

export default EditButton;
